const genders = [
	{ name: 'Male', value: 'MALE' },
	{ name: 'Female', value: 'FEMALE' },
	{ name: 'Rather not say', value: 'UNLISTED' },
]

export default genders
